import React from 'react';
import { Segment, Header, Grid, Tab, Responsive, Loader, SegmentGroup } from 'semantic-ui-react';
import axios from 'axios';
// import { fadeIn, zoomIn } from 'react-animations';
// import { keyframes } from 'styled-components';
// import styled from 'styled-components';
import Notifications from '../Notifications/Notifications';
import ProfessorUpcomingExams from '../Professor/ProfessorUpcomingExams/ProfessorUpcomingExams';
import { FormattedMessage } from 'react-intl';
import SelectCourse from '../Professor/ProfessorInputGrades/SelectCourse';
import SemesterAddedCourses from '../Admin/CreateStudyProgramImplementation/SemesterAddedCourses';
import BasicCourses from '../Admin/CreateStudyProgramImplementation/BasicCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class ProfessorHome extends React.Component {
    constructor(props) {
        super(props);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    render() {
        const panes = [
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.upcomingExamsList" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ProfessorUpcomingExams noSegment />
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.activeExamsList" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <SelectCourse noSegment />
                </Tab.Pane>)
            }
        ];
        // const FadeIn = styled.div`animation: 1s ${keyframes`${zoomIn}`}`;
        return (
            <div >
                <Header as="h1"><FormattedMessage id="sidebar.home" /></Header>
                <Grid centered stackable>
                    <Grid.Row only="mobile tablet">
                        <Grid.Column width={16} stretched >
                            <ProfessorUpcomingExams />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row only="mobile tablet">
                        <Grid.Column width={16} stretched >
                            <SelectCourse />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row only="computer">
                        <Grid.Column width={16} stretched >
                            <SegmentGroup raised>
                                <Segment>
                                    <Header as="h3"><FormattedMessage id="student.exams" /></Header>
                                </Segment>
                                <Segment>
                                    <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} onTabChange={this.handleTabChange} />
                                </Segment>
                            </SegmentGroup>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/ProfessorHome.js